import { post } from '@/services/post'
import { CreateApplicationCommentBody } from '@/types/application/comments'

/**
 * URL : /applications/:applicationId/comments
 */
export function createApplicationsComment(applicationId: string, body: CreateApplicationCommentBody) {
  return post<CreateApplicationCommentBody, { id: string }>(`/applications/${applicationId}/comments`, body)
}
